import { render, staticRenderFns } from "./QueryTag.vue?vue&type=template&id=b92bbb9e&scoped=true"
import script from "./QueryTag.vue?vue&type=script&lang=js"
export * from "./QueryTag.vue?vue&type=script&lang=js"
import style0 from "./QueryTag.vue?vue&type=style&index=0&id=b92bbb9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92bbb9e",
  null
  
)

export default component.exports